import { render, staticRenderFns } from "./mailbox-home.vue?vue&type=template&id=2b7f52b7&"
import script from "./mailbox-home.vue?vue&type=script&lang=ts&"
export * from "./mailbox-home.vue?vue&type=script&lang=ts&"
import style0 from "./mailbox-home.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports